<div class="staff-container mat-elevation-z2">
  <div class="header">
    <h2>Staff Management</h2>
    <div class="actions">
      <button mat-stroked-button color="accent" (click)="openMyProfile()">My Staff Profile</button>
      <button mat-flat-button color="primary" (click)="openCreate()" *ngIf="canManage()">Add Staff</button>
    </div>
  </div>

  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search staff</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Name, email, department, employee ID" />
  </mat-form-field>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 full-width-table">
    <ng-container matColumnDef="employeeId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Staff ID</th>
      <td mat-cell *matCellDef="let s">{{ s.employeeId || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let s">{{ s.fullName }}</td>
    </ng-container>

    <ng-container matColumnDef="department">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Department</th>
      <td mat-cell *matCellDef="let s">{{ s.department || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Position</th>
      <td mat-cell *matCellDef="let s">{{ s.position || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="phoneNumber">
      <th mat-header-cell *matHeaderCellDef>Phone</th>
      <td mat-cell *matCellDef="let s">{{ s.phoneNumber || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let s">{{ s.email || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="isActive">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let s">
        <span class="status" [class.active]="s.isActive" [class.inactive]="!s.isActive">
          {{ s.isActive ? 'Active' : 'Inactive' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let s">
        <button mat-icon-button [matMenuTriggerFor]="staffMenu" [disabled]="!canManage()">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #staffMenu="matMenu">
          <button mat-menu-item (click)="openEdit(s)">
            <mat-icon>edit</mat-icon>
            <span>Edit Staff</span>
          </button>
          <button mat-menu-item (click)="deleteStaff(s)">
            <mat-icon>delete</mat-icon>
            <span>Delete Staff</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>
